export const ORGANIZER_SIGNUP_CHANGE = 'src/Signup/ORGANIZER_SIGNUP_CHANGE';
export const ORGANIZER_SIGNUP_RESET = 'src/Signup/SIGNUP_RESET';
export const ORGANIZER_SET_SIGNUP_LOADING = 'src/Signup/ORGANIZER_SET_SIGNUP_LOADING';
export const ORGANIZER_SET_SIGNUP_SUBMITTING = 'src/Signup/ORGANIZER_SET_SIGNUP_SUBMITTING';
export const ORGANIZER_SET_SIGNUP_FORM_ERRORS = 'src/Signup/ORGANIZER_SET_SIGNUP_FORM_ERRORS';
export const ORGANIZER_SUBSCRIBE_CHANGE = 'src/Signup/ORGANIZER_SUBSCRIBE_CHANGE';
export const ORGANIZER_COMPARE_PASSWORD = 'src/Signup/ORGANIZER_COMPARE_PASSWORD';

export const FETCH_ORGANIZERS = 'src/Organizer/FETCH_ORGANIZERS';
export const FETCH_ORGANIZER_BY_ID = 'src/Organizer/FETCH_ORGANIZER_BY_ID';
export const SET_LOADING = 'src/Organizer/SET_LOADING';
export const RESET_ORGANIZER = 'src/Organizer/RESET_ORGANIZER';
